import { render, staticRenderFns } from "./goods-list.vue?vue&type=template&id=41bd88ca"
import script from "./goods-list.vue?vue&type=script&lang=js"
export * from "./goods-list.vue?vue&type=script&lang=js"
import style0 from "./goods-list.vue?vue&type=style&index=0&id=41bd88ca&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports